/** Default authenticated landing when no explicit deep-link is stored. */
export const POST_AUTH_LANDING_PATH = '/agent' as const;
export const POST_AUTH_LANDING_VIEW = 'agent' as const;

/** Dispatched when OAuth/GIS credential exchange begins — App shows one transition overlay. */
export const AUTH_TRANSITION_START_EVENT = 'ggj:auth-transition-start' as const;

export function startAuthTransition(): void {
  try {
    window.dispatchEvent(new CustomEvent(AUTH_TRANSITION_START_EVENT));
  } catch {
    /* ignore */
  }
}

/** Paths that mean "no deep link" — user should get the default landing. */
export function isGenericPostAuthLanding(path: string | null | undefined): boolean {
  if (!path) return false;
  return path === '/dashboard' || path === POST_AUTH_LANDING_PATH;
}

/**
 * Resolve stored redirect_after_login to the path we should actually navigate to.
 * Stale `/dashboard` (and other generic landings) map to `/agent` for returning users.
 */
export function resolvePostAuthRedirect(stored: string | null | undefined): string {
  if (!stored) return POST_AUTH_LANDING_PATH;
  if (stored === '/payment-success') return '/dashboard';
  if (isGenericPostAuthLanding(stored)) return POST_AUTH_LANDING_PATH;
  return stored;
}
